import { connect } from 'react-redux';

import { getElection, saveAnswersToHash, sendElectionAnswers } from '../actions/questionnaires';
import Election from '../scenes/Election';
import { getResults } from '../utils/results-cache';

const mapStateToProps = ({ voting }) => {
  const election = voting.currentElection;
  const questionsHash = election && election.questionsHash;
  const savedResults = questionsHash ? getResults(questionsHash) : null;
  return {
    election,
    savedResults,
    results: voting.currentElectionResult,
    voteDate: voting.voteDate,
    loading: voting.loading
  };
};

const mapDispatchToProps = (dispatch, { match }) => {
  const { id: questionnaireId } = match.params;
  return {
    getElection: () => {
      dispatch(getElection(questionnaireId));
    },
    sendElectionResults: (districtId, answers) => {
      dispatch(sendElectionAnswers(questionnaireId, districtId, answers));
    },
    saveAnswers: (hashId, answers) => {
      dispatch(saveAnswersToHash(hashId, answers));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Election);
